export enum IncomeLocationEnum {
    local = 'local',
    expat = 'expat',
    pendler = 'pendler',
}
